import { helpers } from 'vuelidate/lib/validators'

export const greaterThanZero = (value) => !helpers.req(value)  || parseFloat(value) > 0;